import { Component, type ReactNode } from 'react';

interface Props {
  children: ReactNode;
  name?: string;
}

interface State {
  hasError: boolean;
  error: Error | null;
}

export class ErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false, error: null };

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, info: React.ErrorInfo) {
    console.error(`[ErrorBoundary:${this.props.name || 'App'}]`, error, info.componentStack);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div
          style={{
            fontFamily: 'Inter, system-ui, sans-serif',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            minHeight: '100vh',
            background: '#050505',
            color: '#f5f5f5',
            padding: '2rem',
            textAlign: 'center',
          }}
        >
          <div
            style={{
              background: 'rgba(214,169,78,0.1)',
              border: '1px solid rgba(214,169,78,0.3)',
              borderRadius: '12px',
              padding: '2rem',
              maxWidth: '480px',
            }}
          >
            <h1
              style={{
                fontSize: '1.5rem',
                fontWeight: 700,
                color: '#d6a94e',
                marginBottom: '0.5rem',
              }}
            >
              Something went wrong
            </h1>
            <p style={{ fontSize: '0.875rem', color: '#94a3b8', marginBottom: '1rem' }}>
              {this.props.name ? `Error in ${this.props.name}` : 'An unexpected error occurred'}
            </p>
            <button
              onClick={() => {
                this.setState({ hasError: false, error: null });
                window.location.reload();
              }}
              style={{
                background: '#d6a94e',
                color: '#050505',
                border: 'none',
                borderRadius: '8px',
                padding: '0.5rem 1.5rem',
                cursor: 'pointer',
                fontSize: '0.875rem',
                fontWeight: 600,
              }}
            >
              Reload Page
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
